var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Container, Input, Form, Card, CardFooter, CardBody, Col } from 'reactstrap';
import { FormattedDate, FormattedMessage, FormattedTime, injectIntl } from 'react-intl';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import Signals from '../../../signals/Signals';
import { ApplicationContext } from '../../../ApplicationContext';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import { FormErrorContext } from '../../../FormErrorContext';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import BasicFormGroup from '../../components/ui/BasicFormGroup/BasicFormGroup';
import DateInput from '../../components/ui/DateInput/DateInput';
import LocationPicker from '../../components/ui/LocationPicker/LocationPicker';
import ManualAssetModel from '../../../models/ManualAssetModel';
import UpdateManualAssetDataCommand from '../../../commands/assets/UpdateManualAssetDataCommand';
import GetOrganisationAssetsCommand from '../../../commands/assets/GetOrganisationAssetsCommand';
import UpdateManualAssetDefinitionCommand from '../../../commands/assets/UpdateManualAssetDefinitionCommand';
import DeleteManualAssetAliasCommand from '../../../commands/assets/DeleteManualAssetAliasCommand';
import Color from 'color';
import { parseFloatToDecimals } from "../../../utils/numberUtils";
/**
 *
 */
var UpdateManualAssetOverlay = /** @class */ (function (_super) {
    __extends(UpdateManualAssetOverlay, _super);
    /**
     *
     * @param props
     */
    function UpdateManualAssetOverlay(props) {
        var _this = _super.call(this, props) || this;
        var assetHasAlias = false;
        _this.state = {
            errors: [],
            submitting: false,
            manualAssetModel: new ManualAssetModel(),
            statusDate: null,
            dateRequired: false,
            aliasChanged: false,
            assetHasAlias: assetHasAlias,
            iconColor: _this.props.assetModel.iconColor,
            displayColorPicker: false,
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onColorChange = _this.onColorChange.bind(_this);
        _this.onIconSelect = _this.onIconSelect.bind(_this);
        _this.deleteAlias = _this.deleteAlias.bind(_this);
        _this.clear = _this.clear.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onStatusDateChange = _this.onStatusDateChange.bind(_this);
        _this.onLocationChange = _this.onLocationChange.bind(_this);
        return _this;
    }
    /**
     *
     */
    UpdateManualAssetOverlay.prototype.componentDidMount = function () {
        var _a;
        var assetModel = this.props.assetModel;
        var _b = this.state, manualAssetModel = _b.manualAssetModel, statusDate = _b.statusDate;
        var assetHasAlias = this.props.assetHasAlias;
        manualAssetModel.updateFromAssetModel(assetModel);
        if (((_a = manualAssetModel.alias) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            assetHasAlias = true;
        }
        this.setState({
            lat: null,
            lon: null,
            newFuelUsedValue: null,
            newCumulativeOperatingHoursValue: null,
            assetHasAlias: assetHasAlias,
            selectedIconName: manualAssetModel.iconName
        });
        this.onStatusDateChange(null, statusDate);
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    UpdateManualAssetOverlay.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     */
    UpdateManualAssetOverlay.prototype.render = function () {
        var _a, _b;
        var assetModel = this.props.assetModel;
        var _c = this.props, className = _c.className, intl = _c.intl;
        var _d = this.state, errors = _d.errors, manualAssetModel = _d.manualAssetModel, statusDate = _d.statusDate, newFuelUsedValue = _d.newFuelUsedValue, newCumulativeOperatingHoursValue = _d.newCumulativeOperatingHoursValue, dateRequired = _d.dateRequired;
        var operationHoursDate = new Date(manualAssetModel.cumulativeOperatingHoursValue.timestamp);
        var fuelUsedDate = new Date(manualAssetModel.fuelUsedInLiters.timestamp);
        return React.createElement(Container, { className: 'update-manual-asset-overlay w-100 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'manual.asset.update.overlay.title' }, manualAssetModel) }),
                        React.createElement(CardBody, { className: 'd-flex' },
                            React.createElement(Col, null,
                                React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'asset.create.overlay.field.alias' }), htmlFor: "alias" },
                                    React.createElement("div", { className: 'input-group input-group-lg  input-group-merge' },
                                        React.createElement(Input, { type: "text", id: "alias", name: "alias", className: 'form-control form-control-appended', value: manualAssetModel.alias }),
                                        React.createElement("div", { className: 'input-group-append' },
                                            React.createElement("div", { className: 'input-group-text' }, manualAssetModel.alias && manualAssetModel.alias.length > 0 ?
                                                React.createElement("span", { className: "fe fe-x cursor-pointer small", onClick: this.clear }) : null)))),
                                React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.serialnumber' }), htmlFor: "serialNumber" },
                                    React.createElement(Input, { type: "text", id: "serialNumber", name: "serialNumber", required: true, disabled: true, value: manualAssetModel.serialNumber })),
                                React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.equipmentid' }), htmlFor: "equipmentId" },
                                    React.createElement(Input, { type: "text", id: "equipmentId", name: "equipmentId", required: true, value: manualAssetModel.equipmentId })),
                                React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.make' }), htmlFor: "make" },
                                    React.createElement(Input, { type: "text", id: "make", name: "make", required: true, value: manualAssetModel.make })),
                                React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.model' }), htmlFor: "model" },
                                    React.createElement(Input, { type: "text", id: "model", name: "model", required: true, value: manualAssetModel.model })),
                                React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.operatinghours' }), htmlFor: "cumulativeOperatingHoursValue" },
                                    React.createElement(Input, { type: "number", min: 0, step: 0.1, id: "cumulativeOperatingHoursValue", name: "cumulativeOperatingHoursValue", placeholder: intl.formatMessage({ id: 'manual.asset.create.overlay.no.update' }) }),
                                    React.createElement("span", { className: "small text-muted d-block" },
                                        intl.formatMessage({ id: 'manual.asset.create.overlay.field.last.known.value' }, { value: ((_a = manualAssetModel.cumulativeOperatingHoursValue.value) !== null && _a !== void 0 ? _a : 0).toString() }),
                                        React.createElement(FormattedDate, { value: operationHoursDate }),
                                        " ",
                                        React.createElement(FormattedTime, { value: operationHoursDate }))),
                                React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.fuelusage' }), htmlFor: "fuelUsedInLiters" },
                                    React.createElement(Input, { type: "number", min: 0, step: 0.1, id: "fuelUsedInLiters", name: "fuelUsedInLiters", placeholder: intl.formatMessage({ id: 'manual.asset.create.overlay.no.update' }) }),
                                    React.createElement("span", { className: "small text-muted d-block" },
                                        intl.formatMessage({ id: 'manual.asset.create.overlay.field.last.known.value' }, { value: ((_b = manualAssetModel.fuelUsedInLiters.value) !== null && _b !== void 0 ? _b : 0).toString() }),
                                        React.createElement(FormattedDate, { value: fuelUsedDate }),
                                        " ",
                                        React.createElement(FormattedTime, { value: fuelUsedDate }))),
                                React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.statusdate' }), htmlFor: "statusDate" },
                                    React.createElement("div", { className: "input-group" },
                                        React.createElement(DateInput, { intl: intl, name: "statusDate", id: "statusDate", className: "w-100", onBlur: this.onStatusDateChange, onChange: this.onStatusDateChange, value: statusDate ? statusDate : null, openToDate: statusDate, required: dateRequired ? true : false, showTimeSelect: true, disableManualInput: true, dateFormat: 'dd-MM-yyyy HH:mm' }),
                                        React.createElement("div", { className: "input-group-append" },
                                            React.createElement("span", { className: "input-group-text" },
                                                React.createElement("i", { className: "fe fe-calendar" })))))),
                            React.createElement(Col, null,
                                React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'manual.asset.create.overlay.field.location' }), htmlFor: "location" },
                                    React.createElement(LocationPicker, { onPositionChange: this.onLocationChange, address: assetModel.place, addressDateString: assetModel.locationDateTime, latitude: manualAssetModel.location.latitude, longitude: manualAssetModel.location.longitude, intl: intl })))),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "page.labels.save" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     * @param color
     * @param event
     */
    UpdateManualAssetOverlay.prototype.onColorChange = function (color, event) {
        this.setState({ iconColor: new Color(color.hex), displayColorPicker: false });
    };
    /**
     *
     * @param selectedIconName
     */
    UpdateManualAssetOverlay.prototype.onIconSelect = function (selectedIconName) {
        this.setState({ selectedIconName: selectedIconName });
    };
    /**
     *
     * @param event
     */
    UpdateManualAssetOverlay.prototype.onInputChange = function (event) {
        var manualAssetModel = this.state.manualAssetModel;
        switch (event.target.name) {
            case 'statusDate':
                break;
            case 'fuelUsedInLiters':
                this.setState({ newFuelUsedValue: parseFloatToDecimals(event.target.value, 1) });
                this.setState({ dateRequired: true });
                break;
            case 'cumulativeOperatingHoursValue':
                this.setState({ newCumulativeOperatingHoursValue: parseFloatToDecimals(event.target.value, 1) });
                this.setState({ dateRequired: true });
                break;
            case 'location':
                this.setState({ dateRequired: true });
                break;
            case 'alias':
                manualAssetModel[event.target.name] = event.target.value;
                this.setState({ aliasChanged: true });
                // Don't set date required state to true
                break;
            default:
                manualAssetModel[event.target.name] = event.target.value;
                this.setState({ dateRequired: true });
        }
    };
    /**
     *
     * @param lat
     * @param lon
     */
    UpdateManualAssetOverlay.prototype.onLocationChange = function (lat, lon) {
        this.setState({ lat: lat, lon: lon, dateRequired: true });
    };
    /**
     *
     * @param event
     */
    UpdateManualAssetOverlay.prototype.deleteAlias = function () {
        var session = this.context.session;
        var intl = this.props.intl;
        var manualAssetModel = this.state.manualAssetModel;
        var command = new DeleteManualAssetAliasCommand();
        command.execute(manualAssetModel, session.user.organisation.id, intl)
            .then(this.onSuccess)
            .catch(this.onError);
    };
    /**
     *
     * @param event
     */
    UpdateManualAssetOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var intl = this.props.intl;
        var _a = this.state, manualAssetModel = _a.manualAssetModel, lat = _a.lat, lon = _a.lon, newFuelUsedValue = _a.newFuelUsedValue, newCumulativeOperatingHoursValue = _a.newCumulativeOperatingHoursValue, statusDate = _a.statusDate, dateRequired = _a.dateRequired, iconColor = _a.iconColor, selectedIconName = _a.selectedIconName;
        var assetHasAlias = this.state.assetHasAlias;
        if (manualAssetModel.alias != null) {
            if (assetHasAlias == true && manualAssetModel.alias.length == 0) {
                this.deleteAlias();
            }
        }
        manualAssetModel.iconColor = iconColor;
        manualAssetModel.iconName = selectedIconName;
        var metricsChanged = false;
        if (dateRequired) {
            var timestamp = statusDate.getTime();
            // Undefined != null returns false, the wanted behaviour
            if (lat != null && lon != null) {
                manualAssetModel.location.latitude = lat;
                manualAssetModel.location.longitude = lon;
                manualAssetModel.location.timestamp = timestamp;
                metricsChanged = true;
            }
            else {
                manualAssetModel.location.latitude = 0;
                manualAssetModel.location.longitude = 0;
                manualAssetModel.location.timestamp = null;
            }
            // Undefined != null returns false, the wanted behaviour
            if (newFuelUsedValue != null) {
                manualAssetModel.fuelUsedInLiters.value = newFuelUsedValue;
                manualAssetModel.fuelUsedInLiters.timestamp = timestamp;
                metricsChanged = true;
            }
            else {
                manualAssetModel.fuelUsedInLiters.value = 0;
                manualAssetModel.fuelUsedInLiters.timestamp = null;
            }
            // Undefined != null returns false, the wanted behaviour
            if (newCumulativeOperatingHoursValue != null) {
                manualAssetModel.cumulativeOperatingHoursValue.value = newCumulativeOperatingHoursValue;
                manualAssetModel.cumulativeOperatingHoursValue.timestamp = timestamp;
                metricsChanged = true;
            }
            else {
                manualAssetModel.cumulativeOperatingHoursValue.value = 0;
                manualAssetModel.cumulativeOperatingHoursValue.timestamp = null;
            }
        }
        var command;
        if (metricsChanged) {
            command = new UpdateManualAssetDataCommand();
        }
        else {
            command = new UpdateManualAssetDefinitionCommand();
        }
        command.execute(manualAssetModel, session.user.organisation.id, intl)
            .then(this.onSuccess)
            .catch(this.onError);
    };
    /**
     *
     */
    UpdateManualAssetOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    UpdateManualAssetOverlay.prototype.clear = function () {
        var manualAssetModel = this.state.manualAssetModel;
        manualAssetModel.alias = "";
        this.setState({
            manualAssetModel: manualAssetModel,
        });
    };
    /**
     *
     */
    UpdateManualAssetOverlay.prototype.onSuccess = function () {
        this.setState({ errors: null, submitting: true });
        Signals.HideOverlay.dispatch();
        var _a = this.context, session = _a.session, assetCollection = _a.assetCollection;
        var user = session.user;
        var intl = this.props.intl;
        // Refresh assets
        var command = new GetOrganisationAssetsCommand();
        // Do show feedback to the user that getting the assets failed, so the user knows the overview is not the latest overview
        // No need for a .then() since the observer will pick up the changes in the asset collection
        command.execute(user.organisation, assetCollection).catch(function () {
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: "error.assets.getcommand" }), 'danger', true);
        });
    };
    /**
     *
     * @param error
     */
    UpdateManualAssetOverlay.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    /**
     *
     * @param e
     * @param date
     */
    UpdateManualAssetOverlay.prototype.onStatusDateChange = function (e, date) {
        console.log('onStatusDateChange', date);
        if (date && !isNaN(date.getTime())) {
            // The date input has no ms precision therefore entering the same date twice can result in a different timestamp 
            // So set ms to 0 explicitly
            date.setMilliseconds(0);
            this.setState({ statusDate: date });
        }
    };
    UpdateManualAssetOverlay.defaultProps = {
        className: ''
    };
    UpdateManualAssetOverlay = __decorate([
        observer
    ], UpdateManualAssetOverlay);
    return UpdateManualAssetOverlay;
}(React.Component));
UpdateManualAssetOverlay.contextType = ApplicationContext;
export default injectIntl(UpdateManualAssetOverlay);
